<template>
  <main>
    <a @click.prevent="$router.go(-1)" href="#" class="link-back"><span class="icon-ico-arrow-left"></span>
      {{ navigationTitle }}</a>
    <FormProspect v-model="data" @submit="onSubmit" ref="formProspect" :disabled="isDetailPage"
      @on-delete="deleteProspect" />
  </main>
</template>
<script>
import FormProspect from "@/components/form/prospect"
import axios from '@/axios';
import { showErrorMessage } from '@/utils';

export default {
  components: {
    FormProspect
  },
  data() {
    return {
      data: {
        converter: "",
        address: "",
        commodity: "",
        application: "",
        status: "",
        description: "",
      },
    }
  },
  methods: {
    async onSubmit() {
      const isValid = await this.$refs.formProspect.$validator.validateAll();
      if (isValid) {
        this.$store.dispatch('toggleLoadingProgress', true)
        axios.put(`/prospects/${this.$route.params.id}`, this.data).then(() => {
          this.$notify({ type: 'success', text: 'Success updating prospect' })
          this.$router.push('/prospects')
        }).catch(error => {
          showErrorMessage(error)
        }).finally(() => {
          this.$store.dispatch('toggleLoadingProgress', false)
        })
      }
    },
    deleteProspect() {
      if (confirm('Are you sure you want to delete this data?')) {
        this.$store.dispatch('toggleLoadingProgress', true)
        axios.delete(`/prospects/${this.$route.params.id}`)
          .then(() => {
            this.$notify({ type: 'success', title: 'Success', text: 'Success delete prospect' })
            this.$router.push('/prospects')
          }).catch(error => {
            showErrorMessage(error)
          }).finally(() => {
            this.$store.dispatch('toggleLoadingProgress', false)
          })
      }
    },
  },
  async mounted() {
    this.$store.dispatch('toggleLoadingProgress', true)
    try {
      const { data } = await axios.get(`/prospects/${this.$route.params.id}`)
      const prospect = data?.data

      if (prospect) {
        Object.assign(this.data, {
          converter: prospect?.converter,
          address: prospect?.address,
          commodity: prospect?.commodity,
          application: prospect?.application,
          status: prospect?.status,
          description: prospect?.description,
        })
      }
    } catch (err) {
      showErrorMessage(err)
      this.$router.push('/prospects')
    } finally {
      this.$store.dispatch('toggleLoadingProgress', false)
    }
  },
  computed: {
    isDetailPage() {
      return this.$route.name === 'DetailProspect'
    },
    navigationTitle() {
      return this.isDetailPage ? 'Detail Prospek' : 'Edit Prospek'
    }
  }
}
</script>

<style></style>
